module.exports = __webpack_public_path__ + "static/p10-60b6a24bfaf29fa8ca4a8ea0e42179f2.png";